import { lazy } from 'react';

// project imports
import Loadable from 'ui-components/loadhandlers/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

const TripGuideCreator = Loadable(lazy(() => import('views/trip-guide/TripGuideCreator')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const TripGuideRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: 'trip-guide-studio',
      element: <TripGuideCreator />
    }
  ]
};

export default TripGuideRoutes;
